import Vue from 'vue';
import Vuex from 'vuex'; //引入 vuex
import store from './store' //注册store

Vue.use(Vuex); //使用 vuex

export default new Vuex.Store({
    state: {
        // 初始化状态
        userInfo: {},
        auth: []
    },
    mutations: {
        // 处理状态
        increment(state, payload) {
            state.userInfo = payload
        },
        auth(state, item) {
            state.auth = item
        }
    },
    actions: {
        // 提交改变后的状态
        increment(context, param) {
            context.commit('increment', param.userInfo)
        },
        getAuth(context, param) {
            context.commit('auth', param.auth)
        }
    }
})